export const shopItems = [
  {
    id: 1,
    name: '"Fix it for the Biscuit" Coaster Set',
    description: 'Set of 4 heavy-duty ceramic coasters. Workshop tested. Beer approved.',
    price: '$24.99',
    badge: 'Best Seller',
    imageUrl: 'https://public.readdy.ai/ai/img_res/16ca510221320af80f941c2194cd8c7f.jpg',
  },
  {
    id: 2,
    name: '"Brew-Wrench" Work Apron',
    description: 'Heavy canvas work apron. Pockets for tools AND a bottle opener. Priorities.',
    price: '$49.99',
    badge: 'New',
    imageUrl: 'https://readdy.ai/api/search-image?query=heavy%20duty%20canvas%20work%20apron%20with%20printed%20wrench%20and%20beer%20mug%20logo%20hanging%20on%20workshop%20pegboard%20with%20tools%20dark%20industrial%20background%20product%20photography%20clean%20presentation&width=400&height=400&seq=shop-apron-baw-2&orientation=squarish',
  },
  {
    id: 3,
    name: '"Cold One Earned" Pint Glass',
    description: 'Etched glass pint. Because your reward deserves a proper vessel.',
    price: '$19.99',
    badge: null,
    imageUrl: 'https://readdy.ai/api/search-image?query=etched%20pint%20glass%20with%20garage%20workshop%20wrench%20logo%20filled%20with%20amber%20craft%20beer%20sweating%20condensation%20on%20dark%20metal%20surface%20dramatic%20lighting%20product%20photography%20minimal%20background&width=400&height=400&seq=shop-pint-baw-3&orientation=squarish',
  },
  {
    id: 4,
    name: '"Garage Hours" Hoodie',
    description: 'Heavyweight fleece. For when the garage gets cold but the fix won\'t wait.',
    price: '$59.99',
    badge: 'Limited',
    imageUrl: 'https://readdy.ai/api/search-image?query=dark%20charcoal%20heavyweight%20hoodie%20with%20embroidered%20wrench%20and%20beer%20mug%20logo%20flat%20lay%20on%20workshop%20bench%20surrounded%20by%20tools%20product%20photography%20moody%20industrial%20lighting&width=400&height=400&seq=shop-hoodie-baw-4&orientation=squarish',
  },
];
